import { render } from "./Detail.vue?vue&type=template&id=1bfb4174"
import script from "./Detail.vue?vue&type=script&lang=js"
export * from "./Detail.vue?vue&type=script&lang=js"
script.render = render

export default script